import { css } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { useAppRoutes } from '@root/features/routing'

import { reatomTradingLeaderboardTable } from '../../atoms'

import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const TradingLeaderboardTable: React.FC<Props> = ({ className }) => {
  const { navigateUserProfile } = useAppRoutes()
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomTradingLeaderboardTable(), [])

  return (
    <AppDataTable
      className={className}
      onRowClick={(entry) => {
        navigateUserProfile(entry.userId)
      }}
      css={css`
        height: 100%;
      `}
      model={model}
      rowHeight={40}
    />
  )
}
